<template>
  <!-- kartica oglasa u traci (pocetna, Tezge / Top oglasi); stilovi: assets/scss/tezgaCard.scss -->
  <div class="item tzc">
    <div class="tzc-top">
      <span v-if="product?.lawyer == 1" class="adr-tz adr-tz-solo"><i class="esei icon-store-solid" aria-hidden="true"></i>Tezga</span>

      <div class="tzc-heart" @click="followerItems(product.id)">
        <i
          class="esei icon-heart heart ml-1"
          :class="followed ? 'place-icon-color-ads-follower' : 'place-icon-color-ads'"
        ></i>
      </div>
    </div>

    <div class="tzc-main">
      <NuxtLink :to="adLink" class="tzc-photo">
        <NuxtImg
          :src="$getImageSrc(product.img)"
          :alt="product.title + ' – pregled cena na pijacama'"
          fit="cover"
          width="60"
          height="60"
          :loading="'eager'"
          :fetchpriority="'high'"
          class="img-ads-br"
        />
      </NuxtLink>

      <div class="tzc-text">
        <NuxtLink
          class="tzc-cat"
          :to="{
            name: 'oglasi-category-page',
            params: { category: $srbTolat.srbTolatPath(product.category_name), page: 1 },
          }"
        >
          {{ product.category_name }}
        </NuxtLink>

        <NuxtLink :to="adLink" class="tzc-title-link">
          <component :is="titleTag" class="tzc-title">{{ product.title }}</component>
        </NuxtLink>
      </div>
    </div>

    <div class="tzc-info">
      <span class="tzc-place">
        <i class="esei icon-map-marker place-icon-color-ads font-size-11"></i>
        {{ product.place_name }}
      </span>

      <span class="tzc-views">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5C7 5 2.7 8.1 1 12c1.7 3.9 6 7 11 7s9.3-3.1 11-7c-1.7-3.9-6-7-11-7z" /><circle cx="12" cy="12" r="3" /></svg>
        <span class="visually-hidden">Pregledi: </span>{{ product.views_count }}
      </span>
    </div>

    <div class="tzc-bottom">
      <NuxtLink :to="adLink" class="tzc-price text-dark">
        {{ displayPrice(product?.price_type, product?.price) }}
        <span>{{ currencySymbol(product.price_type, product.currency_code) }}</span>
      </NuxtLink>

      <NuxtLink
        :to="adLink"
        class="btn font-size-12 tzc-btn"
        :class="product?.coupon == 1 ? 'bg-pijace text-white' : 'btn-primary'"
        :aria-label="`Kupi oglas ${product.title}`"
      >
        <template v-if="product?.coupon == 1">KUPI SA<br>KUPONOM</template>
        <template v-else>KUPI</template>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { useNuxtApp } from '#app'
import { useCustomerLoginStore } from '~/stores/login/customer'

const { $srbTolat } = useNuxtApp()
const routePath = useRoutePath()
const useStoreCustomer = useCustomerLoginStore()

const props = defineProps({
  product: { type: Object, required: true },
  layout: { type: String, default: '' },
  // oznaka naslova oglasa: "div" (obican tekst) ili "h3"/"h4" kad naslov treba da bude naslov
  titleTag: { type: String, default: 'div' },
})

// composables
const { displayPrice, currencySymbol } = usePriceFormat()
const { followed, syncFollowedFromFollowers, toggleFollow } = useAdFollowers()

const followerItems = (id) => toggleFollow(id)

const adLink = computed(() => routePath({
  name: 'oglas-title-id',
  params: { title: props.product.slug || $srbTolat.srbTolatPath(props.product.title), id: props.product.id },
}))

// inicijalno + kad se promeni user ili product
watch(
  () => [props.product?.follower_id, useStoreCustomer.customer?.id],
  () => syncFollowedFromFollowers(props.product?.follower_id),
  { immediate: true }
)
</script>
